/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { EMAProvider, EMAProvider$inboundSchema } from "./emaprovider.js";

/**
 * The EMA providers one vendor authorization server accepts, saved or default. They are stored as an ordered list that identity chaining tries in turn, but each endpoint can use only the provider its sign-in goes through, so the list acts as the set of accepted providers.
 */
export type EMAProviderOrder = {
  /**
   * Nothing is saved, so every provider is accepted. An endpoint whose sign-in trusts an external issuer uses that issuer alone; one that trusts none uses the organization's Speakeasy issuer when it has one.
   */
  isDefault: boolean;
  /**
   * The saved providers in their stored order, or the derived default described by is_default.
   */
  providers: Array<EMAProvider>;
  /**
   * The vendor authorization server issuer, canonicalized.
   */
  vendorIssuer: string;
};

/** @internal */
export const EMAProviderOrder$inboundSchema: z.ZodMiniType<
  EMAProviderOrder,
  unknown
> = z.pipe(
  z.object({
    is_default: z.boolean(),
    providers: z.array(EMAProvider$inboundSchema),
    vendor_issuer: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "is_default": "isDefault",
      "vendor_issuer": "vendorIssuer",
    });
  }),
);

export function emaProviderOrderFromJSON(
  jsonString: string,
): SafeParseResult<EMAProviderOrder, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EMAProviderOrder$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EMAProviderOrder' from JSON`,
  );
}
